<template>
  <!-- 车前急救  -->
  <div class="show-ambulance">
    <div class="video-container">
      <div class="video-player">
        <car-video
          :video-src="videoType1"
          :car-width="529"
          :car-height="338"
        />
        <!--这种属于直播类型的监控视频,只有 护士 || 信息科 需要请求权限-->
        <!-- 如果不是护士的话,下面的代码直接不用显示了 -->
        <el-button
          v-show="(userInfo.loginUserId === 3) && !hasPermission"
          class="permission-button"
          @click="getPermissionForLive"
        >
          <!-- 如果是护士的话,再看看有没有权限 -->
          请求权限
        </el-button>
        <span v-show="!hasVideo" class="permission-button">
          暂无视频
        </span>
      </div>
      <div class="video-player">
        <electronic-car-diagram
          :video-src="videoType2"
          :diogram-width="529"
          :diogram-height="338"
        />
      </div>
      <div class="assistant-help">
        <div class="active-user" :class="{'empty-room-container':!remoteStreamList2.length}">
          <div v-show="!remoteStreamList2.length" class="empty-room">
            当前无用户
          </div>
          <div
            v-for="(item) in remoteStreamList2"
            :key="item.getUserInRoomName"
            class="remote-stream-container"
          >
            <div class="image-body"/>
            <span>{{ item.getUserInRoomName }}</span>
          </div>
        </div>
        <div @click="isShowAssistant = true">协助接入</div>
      </div>
    </div>
    <div class="map-container">
      <div class="map-row">
        <div class="predicate-time">
          预计返程时间：
          <span>{{ leftTime }}分钟</span>
        </div>
        <live-map
          v-if="carID"
          :car-i-d="carID"
          :category="category"
          :width="950"
          :height="700"
          @getLeftTime="getLeftTime"
        />
      </div>
    </div>

    <div class="audio-option">
      <div class="two-refresh-button">
        <div class="refresh-button" @click="getStreamInfo1">
          <i class="el-icon-refresh "/>
          <span>刷新监护仪</span>
        </div>
        <div class="refresh-button" @click="getStreamInfo2">
          <i class="el-icon-refresh "/>
          <span>刷新监控</span>
        </div>
      </div>
      <el-select
        v-model="microphoneId"
        placeholder="请选择"
      >
        <el-option
          v-for="item in deviceList"
          :key="item.deviceId"
          :label="item.label"
          :value="item.deviceId"
        />
      </el-select>
      <el-switch
        v-model="isOpenMic"
        active-color="#13ce66"
        inactive-color="#ff4949"
        active-text="打开麦克风"
        inactive-text="关闭麦克风"
      />
    </div>
    <div class="assistant-dialog">
      <assistant-dialog
        :is-show-assistant="isShowAssistant"
        :patient-i-d="patientID"
        @closeDialog="isShowAssistant = false"
      />
    </div>
    <div class="record-detail" @click="clickDrawer">
      <i class="el-icon-arrow-left"/>
      <span>详情</span>
    </div>
    <div class="drawer-container">
      <my-drawer
        :patient="patientSituation"
        :drawer="isShowDrawer"
        :recognition-text="recognitionText"
        @closeDrawer="isShowDrawer = false"
      />
    </div>

    <div
      v-for="(item) in remoteStreamList"
      :id="item.getUserId()"
      :key="item.getUserId()"
      class="remote-stream-container"
    />
    <!-- 本地流区域 -->
    <div v-if="localStream" class="local-stream-container">
      <!-- 本地流播放区域 -->
      <div id="localStream" class="local-stream-content"/>
      <!-- 本地流操作栏 -->
      <div v-if="isPlayingLocalStream" class="local-stream-control">
        <div class="video-control control">
          <span v-if="!isMutedVideo" @click="muteVideo">
            <svg-icon icon-name="video" class="icon-class"/>
          </span>
          <span v-if="isMutedVideo" @click="unmuteVideo">
            <svg-icon icon-name="video-muted" class="icon-class"/>
          </span>
        </div>
        <div class="audio-control control">
          <span v-if="!isMutedAudio" @click="muteAudio">
            <svg-icon icon-name="audio" class="icon-class"/>
          </span>
          <span v-if="isMutedAudio" @click="unmuteAudio">
            <svg-icon icon-name="audio-muted" class="icon-class"/>
          </span>
        </div>
      </div>
    </div>
    <my-dialog
      :dialog-carted="infoDialog"
      form-title="提示"
      :width="320"
      @confirmOk="infoDialog = false"
    >
      <template #content>
        <div>{{ infoDialogMessage }}</div>
      </template>
    </my-dialog>
  </div>
</template>
<script>
import AssistantDialog from "@components/customDialog/AssistantDialog";
import CarVideo from "@components/stream/CarVideo";
import ElectronicCarDiagram from "@components/stream/Electrocardiogram";
import MyDrawer from "@components/Drawers/MyDrawer";
import MyDialog from "@components/customDialog/MyDialog";
import LiveMap from "@components/MapContainer/LiveMap";
import { getTencentToken } from "@api/streamdata";
import { mapState } from "vuex";
import { showWindowMessage } from "@utils/notification";
import TRTC from "trtc-js-sdk";
import rtc from "@components/trtc/mixins/rtc";
import shareRtc from "@components/trtc/mixins/share-rtc";
import tool from "@views/AmbulanceLive/tool";
import SvgIcon from "@components/common/svg-icon";
import { getUser } from "@api/user";

export default {
  name: "AmbulanceLive",
  components: {
    MyDialog,
    AssistantDialog,
    MyDrawer,
    LiveMap,
    CarVideo,
    ElectronicCarDiagram,
    SvgIcon
  },
  mixins: [rtc, shareRtc, tool],
  data() {
    return {
      sdkAppId: "",
      deviceType: "microphone",
      secretKey: "",
      hasVideo: false, // 当前是否有视频(需要显示权限的)
      userId: "",
      roomId: "",
      microphoneId: "",
      inviteLink: "",
      logList: [],
      leftTime: 0, // 急救车返程时间
      carID: 0, // 当前急救车id
      isShowAssistant: false,
      isShowDrawer: false, // 展示Drawer 抽屉
      isOpenMic: false, // 是否打开麦克风推流
      videoType2: "webrtc://", // 救护仪器
      videoType1: "webrtc://", // 摄像头和麦克风
      patientID: 0, // 当前急救车接送/处理 的病人ID
      hasPermission: false, // 总的判断是否有权限
      patientSituation: {},
      publisher: null,
      infoDialog: false,
      infoDialogMessage: "",
      deviceList: [],
      category: "",
    };
  },
  computed: {
    // isHostMode() {
    //   return this.type !== "invite";
    // },
    ...mapState({
      ambulanceLists: "ambulanceLists",
      currentList: "currentList",
      hospitalID: "hospitalID",
      userInfo: "userInfo",
    }),
    remoteStreamList2() {
      this.remoteStreamList.forEach(async item => {
        const id = item.getUserId();
        if (id === "1a") {
          item.getUserInRoomName = "急救车";
        } else {
          item.getUserInRoomName = await this.getInRoomName(id);
        }
      });

      return this.remoteStreamList;
    },
  },
  watch: {
    // cameraId(val) {
    //   this.switchDevice("video", val);
    // },
    microphoneId(val) {
      this.switchDevice("audio", val);
    },
    currentList: {
      handler(val) {
        if (this.carID) {
          this.patientSituation = val.find(mission => {
            return mission.ambulanceId === this.carID;
          }) || {};
        }
      },
      immediate: true
    },
    isOpenMic: {
      handler(val) {
        if (val) {
          this.startPushAudio();
        } else {
          this.publisher && this.publisher.close();
        }
      },
      immediate: true
    }
  },
  beforeUnmount() {
    console.log("-------delete aside ---");
    if (this.publisher) {
      this.publisher.close();
    }
    this.handleLeave();
    navigator.mediaDevices.removeEventListener("devicechange", this.getDeviceList);
  },
  mounted() {
    this.getBasicData(); // 拿到当前发车的事例
    this.category = this.$route.query.category;
  },
  methods: {
    async getInRoomName(id) {
      const {
        realName
      } = await getUser(id);
      return realName;
    },
    async getDeviceList() {
      switch (this.deviceType) {
        case "camera":
          this.deviceList = await TRTC.getCameras();
          break;
        case "microphone":
          this.deviceList = await TRTC.getMicrophones();
          break;
        case "speaker":
          this.deviceList = await TRTC.getSpeakers();
          break;
        default:
          break;
      }
      this.microphoneId = this.deviceList[0]?.deviceId;
      if (!this.microphoneId) {
        alert("没有检测到麦克风, 请先插入麦克风");
      }
      await this.handleJoinRoom();
    },
    // 点击【Join Room】按钮
    async handleJoinRoom() {
      const { code, user_sig, sdk_id } = await getTencentToken(this.userInfo.id);
      this.sdkAppId = sdk_id;
      this.userSig = user_sig;
      if (code !== 200) {
        alert("从服务器获取音视频密钥失败, 请刷新网页或者联系开发人员");
        return;
      }
      if (!this.roomId) {
        alert("房间号不存在无法加入,请刷新网页或者联系开发人员");
        return;
      }
      await this.initClient();
      try {
        await this.join();
        await this.initLocalStream();
        await this.playLocalStream();
        await this.publish();
        // this.generateInviteLink();
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    /**
     * 点击右侧边栏 (详情)
     * */
    clickDrawer() {
      if (this.patientSituation.id) {
        this.isShowDrawer = true;
      } else {
        showWindowMessage(3, "当前车辆没有任务, 无法查看详情!", this);
      }
    },
    getLeftTime(leftTime) {
      this.leftTime = Math.round(leftTime / 60);
    },
    async getBasicData() {
      this.carID = Number(this.$route.params.id);
      const currentMission = this.currentList.find(e => e.ambulanceId === this.carID);
      await this.getStreamInfo();
      if (!currentMission) { // 如果没有任务的话
        return;
      }
      this.patientSituation = currentMission;
      /**
       * 医生协助房间号生成方法
       * 拿到病历号, 拼接上字符串2, 变成长字符串
       * 再删除前两位 组成10位的字符串
       */
      const number = `${currentMission.number}2`;
      this.roomId = number.slice(2) * 1;
      this.userId = this.userInfo.id + "";
      this.patientID = currentMission.id;
      navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then(() => {
        this.getDeviceList();
      });
      navigator.mediaDevices.addEventListener("devicechange", this.getDeviceList);
    },
    // 点击【Publish】按钮
    async handlePublish() {
      await this.publish();
    },

    // 点击【Unpublish】按钮
    async handleUnpublish() {
      await this.unPublish();
    },
    // 点击【Leave Room】按钮
    async handleLeave() {
      await this.leave();
    },
    // 显示成功的 Log
    addSuccessLog(log) {
      if (!this.isHostMode) {
        return;
      }
      this.logList.push({
        type: "success",
        log,
      });
      // const { scrollHeight } = this.$refs.logContainer;
      // this.$refs.logContainer.scrollTop = scrollHeight;
    },

    // 显示失败的 Log
    addFailedLog(log) {
      if (!this.isHostMode) {
        return;
      }
      this.logList.push({
        type: "failed",
        log,
      });
      // const { scrollHeight } = this.$refs.logContainer;
      // this.$refs.logContainer.scrollTop = scrollHeight;
    },
    reportSuccessEvent(name) {
      // this.$aegis.reportEvent({
      //   name,
      //   ext1: `${name}-success`,
      //   ext2: "webrtcQuickDemoVue2",
      //   ext3: this.sdkAppId,
      // });
    },
    reportFailedEvent(name, error, type = "rtc") {
      // this.$aegis.reportEvent({
      //   name,
      //   ext1: `${name}-failed#${this.roomId}*${type === "share" ? this.shareUserId : this.userId}*${error.message}`,
      //   ext2: "webrtcQuickDemoVue2",
      //   ext3: this.sdkAppId,
      // });
    },

  }
};
</script>
<style scoped lang="scss">
.show-ambulance {
  margin-top: 24px;
  display: flex;
}

.video-container:hover {
  .assistant-help {
    display: block;
  }
}

.video-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-direction: column;

  .assistant-help {
    display: none;
    width: 84px;
    height: 28px;
    line-height: 28px;
    background: #FBFBFB;
    border-radius: 14px;
    position: absolute;
    right: 160px;
    bottom: 48px;
    text-align: center;
    cursor: pointer;

    .image-body {
      background: url(../../assets/photos2/user.png) no-repeat center center;
      width: 30px;
      height: 30px;
      margin: auto;
    }

    .active-user {
      display: none;
    }

    .remote-stream-container {
      padding: 10px;
    }
  }

  .assistant-help:hover {
    .empty-room-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .active-user {
      display: flex;
      position: absolute;
      bottom: 36px;
      left: -50%;
      transform: translateX(-10px);
      width: 192px;
      height: 88px;
      background: #FFFFFF;
      box-shadow: 0 0 8px 0 rgba(127, 147, 166, 0.4);
      border-radius: 6px;
    }
  }
}

.map-container {
  width: 1005px;
  background: #FBFBFB;
  border-radius: 10px;
  margin-left: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  .map {
    width: 617px;
    height: 612px;
    border-radius: 10px;
    background: #333;
  }
}

.map-row {
  position: relative;
}

.predicate-time {
  position: absolute;
  left: 10px;
  bottom: 4px;
  z-index: 161;
  text-align: center;
  vertical-align: bottom;
  line-height: 50px;
  font-size: 22px;
  font-weight: bold;
  color: #666666;
  width: 260px;
  height: 48px;
  background: #FBFBFB;
  box-shadow: 0 0 8px 0 rgba(127, 147, 166, 0.4);
  border-radius: 10px;
}

::v-deep .assistant-dialog {
  .el-dialog__body {
    padding: 24px;
    text-align: left;
  }

  .el-input__inner {
    width: 140px;
    height: 32px;
    border: 1px solid #999999;
    border-radius: 10px;
    box-shadow: none;
    background: transparent;
  }

  .el-checkbox__inner {
    width: 20px;
    height: 20px;
    border: 1px solid #999999;
    border-radius: 6px;
  }

  .el-checkbox__label {
    font-size: 16px;
    font-weight: 400;
    color: #999999;
  }
}

.record-detail {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 52px;
  height: 62px;
  background: #FBFBFB;
  border-radius: 10px 0 0 10px;
  cursor: pointer;

  span {
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
  }
}

.drawer-container ::v-deep {
  .el-drawer__body {
    padding: 24px 30px;
  }

  .el-tabs,
  .el-tabs__content,
  .el-tab-pane {
    overflow: auto;
  }
}

.audio-option {
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-player + .video-player {
  margin-top: 20px;
}

.video-player {
  width: 560px;
  height: 364px;
  background: #FBFBFB;
  border-radius: 10px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;

  .permission-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.two-refresh-button {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  cursor: pointer;
}

</style>
